<div style="padding: 20px">
  <h2>
    <b>Steps Summary</b>
    <button type="button" class="btn-close shadow-none" (click)="onClose()" title="Close"></button>
  </h2>
  <div class="parent">
    <div class="toggle-btn">
      <mat-button-toggle-group class="supply-mode-toggle inline" [ngModel]="supply_mode" (ngModelChange)="onSupplyModeChange($event)" [ngModelOptions]="{ standalone: true }">
        <mat-button-toggle
          *ngFor="let param of supplyModeParam"
          [ngClass]="!param.is_active ? 'disable' : ''"
          [disabled]="!param.is_active"
          [value]="param.key"
          [attr.title]="!param.is_active ? 'Access Restricted' : ''"
          >{{ param.description }}</mat-button-toggle
        >
      </mat-button-toggle-group>
    </div>

    <div class="dialog-header">
      <!-- <button class="mdlz-btn-outline shadow-bottom round-button"  (click)="exportPdf()"><img src="assets/images/download.svg" alt="PDF">
        PDF
    </button> &nbsp;  &nbsp; &nbsp;  &nbsp; &nbsp;  &nbsp; -->
      <button class="mdlz-btn-outline shadow-bottom ex" (click)="exportExcel()">
        <div class="icon-text">
          <img src="assets/images/download.svg" alt="PDF" />
          <span>Excel</span>
        </div>
      </button>
    </div>
  </div>
  <br />
  <p-table [value]="masterData" styleClass="p-datatable-striped" class="summary-table" [scrollable]="true" scrollHeight="850px" dataKey="steps">
    <ng-template pTemplate="header">
      <tr>
        <td pSortableColumn="Steps" class="th">Steps<p-sortIcon field="Steps"></p-sortIcon></td>
        <td pSortableColumn="period" class="th">Period<p-sortIcon field="period"></p-sortIcon></td>
        <td pSortableColumn="manufacturing_network" class="th">Mfg. Network<p-sortIcon field="manufacturing_network"></p-sortIcon></td>
        <td pSortableColumn="node_code" class="th">Plant<p-sortIcon field="node_code"></p-sortIcon></td>
        <td pSortableColumn="im_line_code" class="th">Production Line<p-sortIcon field="im_line_code"></p-sortIcon></td>
        <td pSortableColumn="shifts_change" class="th">Shift<p-sortIcon field="shifts_change"></p-sortIcon></td>
        <td pSortableColumn="inc_shifts" class="th">Inc. Capacity Shift<p-sortIcon field="inc_shifts"></p-sortIcon></td>
        <td pSortableColumn="ge_change" class="th">GE (% Change)<p-sortIcon field="ge_change"></p-sortIcon></td>
        <td pSortableColumn="inc_ge" class="th">Inc. Capacity GE<p-sortIcon field="inc_ge"></p-sortIcon></td>
        <td pSortableColumn="ge_capex" class="th">Capex GE<p-sortIcon field="ge_capex"></p-sortIcon></td>
        <td pSortableColumn="wastage_change" class="th">Waste (% Change)<p-sortIcon field="wastage_change"></p-sortIcon></td>
        <td pSortableColumn="inc_wastage" class="th">Inc. Capacity Waste<p-sortIcon field="inc_wastage"></p-sortIcon></td>
        <td pSortableColumn="wastage_capex" class="th">CAPEX Waste<p-sortIcon field="wastage_capex"></p-sortIcon></td>
        <td pSortableColumn="inc_em" class="th">Increase EM<p-sortIcon field="inc_em"></p-sortIcon></td>
        <td pSortableColumn="" class="th">New Lines (AR/New Install)<p-sortIcon field=""></p-sortIcon></td>
        <td pSortableColumn="new_capex" class="th">CAPEX New Lines<p-sortIcon field="new_capex"></p-sortIcon></td>
        <td pSortableColumn="inc_capacity" class="th">Inc. Capacity New Lines<p-sortIcon field="inc_capacity"></p-sortIcon></td>
        <td pSortableColumn="final_ge" class="th">Final GE<p-sortIcon field="final_ge"></p-sortIcon></td>
        <td pSortableColumn="final_wastage" class="th">Final Wastage<p-sortIcon field="final_wastage"></p-sortIcon></td>
        <td pSortableColumn="final_capacity" class="th">Final Capacity<p-sortIcon field="final_capacity"></p-sortIcon></td>
        <td pSortableColumn="final_shifts" class="th">Final Shifts<p-sortIcon field="final_shifts"></p-sortIcon></td>
        <td pSortableColumn="tmax" class="th">Tmax<p-sortIcon field="tmax"></p-sortIcon></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-masterData>
      <tr>
        <td>{{ masterData.Steps }}</td>
        <td>{{ masterData.period }}</td>
        <td>{{ masterData.manufacturing_network }}</td>
        <td>{{ masterData.node_code }}</td>
        <td>{{ masterData.im_line_code }}</td>
        <td>{{ masterData.shifts_change | number : '1.1-2' }}</td>
        <td>{{ masterData.inc_shifts | number : '1.1-2' }}</td>
        <td>{{ masterData.ge_change | number : '1.1-2' }}</td>
        <td>{{ masterData.inc_ge | number : '1.1-2' }}</td>
        <td>{{ masterData.ge_capex | number : '1.1-2' }}</td>
        <td>{{ masterData.wastage_change | number : '1.1-2' }}</td>
        <td>{{ masterData.inc_wastage | number : '1.1-2' }}</td>
        <td>{{ masterData.wastage_capex | number : '1.1-2' }}</td>
        <td>{{ masterData.inc_em | number : '1.1-2' }}</td>
        <td>0</td>
        <td>{{ masterData.new_capex | number : '1.1-2' }}</td>
        <td>{{ masterData.inc_capacity | number : '1.1-2' }}</td>
        <td>{{ masterData.final_ge | number : '1.1-2' }}</td>
        <td>{{ masterData.final_wastage | number : '1.1-2' }}</td>
        <td>{{ masterData.final_capacity | number : '1.1-2' }}</td>
        <td>{{ masterData.final_shifts | number : '1.1-2' }}</td>
        <td>{{ masterData.tmax | number : '1.1-2' }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
